export default __webpack_public_path__ + "static/media/award1.5b54ccea.svg";